<template>
  <button :class="['video__link', {'--large': large}]" @click="content.link.includes('youtube.com') ? $store.dispatch('updateYoutubeId', id) : $store.dispatch('updateVideoContent', content.link)">
    <Icon id="play"/>
    <span>{{ content.label }}</span>
  </button>
</template>

<script>
import {Icon} from '@/components/global'
import {HasContentMixin} from '@/mixins'

export default {
  name: 'VideoLink',
  mixins: [HasContentMixin],
  components: {Icon},
  props: {
    large: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    id() {
      return new URL(this.content.link).searchParams.get('v')
    }
  }
}
</script>